import { render, staticRenderFns } from "./DropdownNavigationItem.vue?vue&type=template&id=2f3a4a03&scoped=true"
import script from "./DropdownNavigationItem.vue?vue&type=script&lang=js"
export * from "./DropdownNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./DropdownNavigationItem.vue?vue&type=style&index=0&id=2f3a4a03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a4a03",
  null
  
)

export default component.exports